import type { PixelConfig, PixelEvent } from "./types.js";

/**
 * Ships an envelope to POST {endpoint}/v1/events. Uses `keepalive` so events fired during
 * page-unload (checkout_start, session_end) still flush. The per-store key goes in X-Site-Id —
 * the same untrusted client header ingestion's client plane reads (apps/api/routes/ingest.ts).
 * Failures are swallowed: tracking must never break the storefront. Returns true on a 2xx.
 */
export interface Transport {
  send(event: PixelEvent): Promise<boolean>;
}

export function createTransport(config: PixelConfig): Transport {
  const url = `${config.endpoint.replace(/\/+$/, "")}/v1/events`;
  return {
    async send(event: PixelEvent): Promise<boolean> {
      try {
        const res = await fetch(url, {
          method: "POST",
          headers: {
            "content-type": "application/json",
            "x-site-id": config.siteId,
          },
          body: JSON.stringify(event),
          keepalive: true,
          credentials: "omit",
          mode: "cors",
        });
        return res.ok;
      } catch {
        return false;
      }
    },
  };
}
